import { useState } from "react";

const AddColumnModal = ({ onClose, onSubmit }) => {
    const [columnTitle, setColumnTitle] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (columnTitle.trim()) {
            onSubmit(columnTitle.trim());
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="bg-gray-800 rounded-lg p-6 w-full max-w-sm shadow-xl relative text-white">
                <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-white p-2 rounded-full hover:bg-gray-700 transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <h2 className="text-2xl font-bold mb-6 text-center">Add New Column</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="columnTitle" className="block text-sm font-medium text-gray-300 mb-1 text-start">Column Title</label>
                        <input
                            type="text"
                            id="columnTitle"
                            className="w-full p-2 bg-gray-700 border border-gray-600 rounded-md focus:ring-blue-500 focus:border-blue-500 outline-none"
                            value={columnTitle}
                            onChange={(e) => setColumnTitle(e.target.value)}
                            required
                            autoFocus
                        />
                    </div>
                    <div className="flex justify-end space-x-3 mt-6">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-md font-medium transition-colors duration-200"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium transition-colors duration-200"
                        >
                            Add Column
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};


export default AddColumnModal